<template>
  <ModalComponent
    ref="modalRef"
    size="xl"
    submitButtonText=""
    noFooter
    :dismissible="!reviewOpen"
    @close="$emit('close')"
  >
    <template #title>Report consumption</template>
    <template #body>
      <!-- The shared modal body carries no vertical padding of its own (the footer normally
           closes it off); with no footer, the content has to. -->
      <div class="pt-2 pb-4">
        <ConsumptionReport :domain :view v-model:reviewOpen="reviewOpen" />
      </div>
    </template>
  </ModalComponent>
</template>

<script setup lang="ts">
import type {
  ConsumptionView,
  DerivedDomain,
} from "@/compliance_groups/fixture/derive";
import ModalComponent from "@/components/common/ModalComponent.vue";
import { onMounted, ref, useTemplateRef } from "vue";
import ConsumptionReport from "./ConsumptionReport.vue";

defineProps<{ domain: DerivedDomain; view: ConsumptionView }>();
defineEmits<{ close: [] }>();

// Both modals listen for Escape on the document, so while the confirm dialog is open the
// report modal must ignore Escape and backdrop clicks or one key press closes both.
const reviewOpen = ref(false);

const modalRef =
  useTemplateRef<InstanceType<typeof ModalComponent>>("modalRef");
onMounted(() => modalRef.value?.toggleModal());
</script>
